import { GanttIcon } from "./GanttControls";

const GanttAssistant = ({
  chat,
  hidden,
  instruction,
  isFullscreen,
  loading,
  hasItems,
  onAsk,
  onHide,
  onInstructionChange,
  onShow
}) => {
  if (isFullscreen) return null;

  if (hidden) {
    return (
      <aside className="gantt-assistant-rail">
        <button className="gantt-assistant-toggle" aria-label="Show Gantt assistant" title="Show assistant" onClick={onShow}>
          <GanttIcon name="arrowLeft" />
        </button>
      </aside>
    );
  }

  return (
    <aside className="gantt-assistant">
      <div className="gantt-assistant-header">
        <h2>Gantt assistant</h2>
        <button className="gantt-assistant-toggle" aria-label="Hide Gantt assistant" title="Hide assistant" onClick={onHide}>
          <GanttIcon name="arrowRight" />
        </button>
      </div>
      <div className="gantt-chat">
        {!chat.length && <p>Ask the assistant to parallelize work, explain risks, move epics, or rebalance the schedule.</p>}
        {chat.map((item, index) => <div key={index} className={`gantt-chat-message ${item.role}`}>{item.content}</div>)}
      </div>
      <textarea value={instruction} onChange={(event) => onInstructionChange(event.target.value)} placeholder="How should the schedule change?" />
      <button onClick={onAsk} disabled={loading || !instruction.trim() || !hasItems}>Send to assistant</button>
    </aside>
  );
};

export default GanttAssistant;
